module.exports = __webpack_public_path__ + "static/img/logo44.7fb1ec5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo44.png
// module id = taeY
// module chunks = 1